<template>
  <v-form
    ref="form"
    v-model="valid"
  >
    <v-row dense>
      <v-col
        cols="12"
        class="font-weight-semibold"
      >
        Quantity:
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="temp_quantity"
          outlined
          dense
          hide-details="auto"
          :rules="[$rules.required, checkMinQuantity, checkMaxQuantity]"
          @input="changeQuantity(true)"
        />
      </v-col>
      <v-col cols="12">
        <v-slider
          v-model="edit_item.quantity"
          :min="minQuantity"
          :max="maxQuantity"
          hide-details
          @end="changeQuantity(false)"
        >
          <template #prepend>
            <div
              class="body-2 mt-1"
              style="white-space: nowrap"
            >
              Min: {{ minQuantity }}
            </div>
          </template>
        </v-slider>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col
        cols="12"
        class="font-weight-semibold"
      >
        Color:
      </v-col>
      <v-col
        v-for="part in parts"
        :key="part.id"
        cols="auto"
      >
        <mcs-sheet
          dense
          :class="{
            'hover-pointer': part.isAvailable,
            'border-primary': edit_item.partId == part.id
          }"
          :outlined="edit_item.partId == part.id"
          :title="part.isAvailable ? '' : 'Unavailable'"
          :style="{ opacity: part.isAvailable ? 1 : 0.25 }"
          @click="clickPartCard(part)"
        >
          <v-img
            :src="part.imageUrl"
            max-height="100"
            max-width="50"
            contain
          />
        </mcs-sheet>
      </v-col>
      <v-col cols="12">
        {{ part.colorName }}
      </v-col>
    </v-row>
    <v-row dense>
      <v-col
        cols="12"
        class="font-weight-semibold"
      >
        Decoration Type:
      </v-col>
      <v-col cols="12">
        <v-select
          v-model="edit_item.isDecorated"
          outlined
          dense
          :items="decorationTypes"
          item-text="name"
          item-value="id"
          hide-details="auto"
          @input="changeDecorated"
        />
      </v-col>
      <template v-if="edit_item.isDecorated">
        <v-col
          cols="12"
          class="font-weight-semibold"
        >
          Location:
        </v-col>
        <v-col cols="12">
          <template v-if="locations.length == 1">
            {{ locations[0].name }}
          </template>
          <v-select
            v-else
            v-model="edit_item.locationId"
            outlined
            dense
            :items="locations"
            item-text="name"
            item-value="id"
            hide-details="auto"
            :rules="[$rules.required]"
            @input="changeLocation"
          />
        </v-col>
        <v-col
          cols="12"
          class="font-weight-semibold"
        >
          Decoration Technology:
        </v-col>
        <v-col cols="12">
          <template v-if="decorations.length == 1">
            {{ decorations[0].name }}
          </template>
          <v-select
            v-else
            v-model="edit_item.decorationId"
            outlined
            dense
            :items="decorations"
            item-text="name"
            item-value="id"
            hide-details="auto"
            :rules="[$rules.required]"
            @input="changeDecoration"
          />
        </v-col>
        <v-col
          cols="12"
          class="font-weight-semibold"
        >
          Decoration Color:
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="edit_item.decorationColorId"
            outlined
            dense
            :items="decoration_colors"
            item-text="name"
            item-value="id"
            hide-details="auto"
            :rules="[$rules.required]"
            @change="setTempEditItem"
          />
        </v-col>
      </template>
    </v-row>
  </v-form>
</template>

<script>
import { ANALYTICS_EVENTS, DRAWERS } from '@/utils/constants';
import promo from '@/utils/mixins/promo';
import { orderBy } from 'lodash';
import { mapGetters } from 'vuex';

export default {
  components: {},

  mixins: [promo],
  props: { store: { type: String, default: 'printcart' } },

  data: () => ({
    saving: false,
    valid: true,
    loading: false,
    loaded: false,
    uploading: false,
    temp_quantity: 0,
    temp_edit_item: {}
  }),

  computed: {
    isAdd() {
      return !this.edit_item.id;
    },

    minQuantity() {
      return (
        (this.edit_item.isDecorated
          ? this.part.minimumDecoratedQuantity
          : this.part.minimumBlankQuantity) || 0
      );
    },

    maxQuantity() {
      return this.part.currentAvailable;
    },

    decorationTypes() {
      return [
        { id: true, name: 'Decorated' },
        { id: false, name: 'Blank' }
      ];
    },

    edit_item: {
      get() {
        return this.$store.getters[`${this.store}/edit_item`];
      },
      set(val) {
        this.$store.dispatch(`${this.store}/setEditItem`, val);
      }
    },

    loading_price: {
      get() {
        return this.$store.getters[`${this.store}/loading_price`];
      },
      set(val) {
        this.$store.dispatch(`${this.store}/setLoadingPrice`, val);
      }
    },

    ...mapGetters({})
  },

  watch: {
    'edit_item.productId'(val, oldVal) {
      if (val !== oldVal && oldVal && val) {
        console.log('firing from edit_item.productId watcher');
        this.getPromoProduct();
      }
    },
    'edit_item.quantity'(val, oldVal) {
      this.temp_quantity = val;
    }
  },

  mounted() {
    this.temp_quantity = this.edit_item.quantity;
  },

  methods: {
    getPrice(skipValidation, updateQuantity) {
      if (skipValidation || (this.$refs.form && this.$refs.form.validate())) {
        if (updateQuantity) {
          this.$set(this.edit_item, 'quantity', this.temp_quantity);
        }
        this.loading_price = true;
        this.$store
          .dispatch(`${this.store}/getPromoPrice`, this.edit_item)
          .then((data) => {
            this.$set(this.edit_item, 'leadDays', data.leadDays);
            this.$set(this.edit_item, 'basePrice', data.basePrice);
            this.$set(this.edit_item, 'baseCost', data.baseCost);
          })
          .catch((error) => {
            this.logError(error, 'An error occurred while loading price.');
            this.$mixpanel.trackEvent(
              ANALYTICS_EVENTS.PROMO.NAME,
              ANALYTICS_EVENTS.PROMO.ACTIONS.CART_ERROR,
              { message: 'Error getting price. ' + error.message }
            );
          })
          .finally(() => {
            this.loading_price = false;
          });
      }
    },

    getPromoProduct(initial, showShipping, skipSetup) {
      this.$store
        .dispatch(`${this.store}/getPromoProduct`, this.edit_item.productId)
        .then(() => {
          if (!skipSetup) {
            if (this.isAdd || !initial) {
              const part = orderBy(this.parts, ['isDefault'], [true])[0];
              this.$set(this.edit_item, 'partId', part.id);
              if (this.edit_item.isDecorated === undefined) {
                this.$set(this.edit_item, 'isDecorated', true);
              }
              this.$set(
                this.edit_item,
                'locationId',
                orderBy(this.locations, ['isDefault'], [true]).map((x) => x.id)[0]
              );
              this.$set(
                this.edit_item,
                'decorationId',
                orderBy(this.decorations, ['isDefault'], [true]).map((x) => x.id)[0]
              );
              this.$set(
                this.edit_item,
                'decorationColorId',
                this.decoration_colors.map((x) => x.id)[0]
              );
            }
          }
          if (this.edit_item.quantity < this.minQuantity) {
            this.$set(this.edit_item, 'quantity', this.minQuantity);
          }
          if (initial) {
            this.$nextTick(() => {
              console.log('calling getPrice() from getPromoProduct');
              this.getPrice();
            });
          }
          if (!initial) {
            this.changeQuantity();
          }
          if (showShipping) {
            this.showShipping();
          }
          this.$nextTick(() => {
            this.$refs.form.resetValidation();
            this.setTempEditItem();
          });
        })
        .catch((error) => {
          this.logError(error, 'An error occurred while loading PROMO checkout.');
          this.$mixpanel.trackEvent(
            ANALYTICS_EVENTS.PROMO.NAME,
            ANALYTICS_EVENTS.PROMO.ACTIONS.CART_ERROR,
            { message: 'Error getting products. ' + error.message }
          );
        })
        .finally(() => {
          this.$emit('loaded');
          this.loading = false;
        });
    },

    changePart() {
      const location =
        this.locations.find((x) => x.externalId === this.temp_edit_item.externalLocationId) ??
        this.locations.find((x) => x.isDefault) ??
        this.locations[0];
      this.$set(this.edit_item, 'locationId', location.id);
      this.changeLocation();
    },

    changeDecorated() {
      this.$nextTick(() => {
        console.log('calling getPrice() from changeDecorated');
        this.getPrice();
      });
    },

    changeLocation() {
      const decoration =
        this.decorations.find((x) => x.externalId === this.temp_edit_item.externalDecorationId) ??
        this.decorations.find((x) => x.isDefault) ??
        this.decorations[0];
      this.$set(this.edit_item, 'decorationId', decoration.id);
      this.changeDecoration();
    },

    changeDecoration() {
      const decorationColor =
        this.decoration_colors.find(
          (x) => x.externalId === this.temp_edit_item.externalDecorationColorId
        ) ??
        this.decoration_colors.find((x) => x.isDefault) ??
        this.decoration_colors[0];
      this.$set(this.edit_item, 'decorationColorId', decorationColor.id);
      this.edit_item = Object.assign(this.edit_item, {
        finalPublicId: null,
        finalImageUrl: null,
        originalPublicId: null,
        originalImageUrl: null
      });

      this.setTempEditItem();

      this.$nextTick(() => {
        console.log('calling getPrice() from changeDecoration');
        this.getPrice();
      });
    },

    changeQuantity(updateQuantity) {
      this.$nextTick(() => {
        console.log('calling getPrice() from changeQuantity');
        this.getPrice(false, updateQuantity);
      });
      this.clearDelivery();
    },

    clearDelivery() {
      this.edit_item.delivery = { earliestDate: null };
    },

    showShipping() {
      this.$store.commit('drawers/SET_DATA', {
        drawerId: DRAWERS.PRINT_CHECKOUT_SHIPPING,
        data: {}
      });
      this.$store.commit('drawers/OPEN_DRAWER', DRAWERS.PRINT_CHECKOUT_SHIPPING);
    },

    checkMinQuantity(v) {
      if (v < this.minQuantity) {
        return `Quantity must be at least ${this.minQuantity}`;
      }
      return true;
    },
    checkMaxQuantity(v) {
      if (v > this.maxQuantity) {
        return `Only ${this.maxQuantity} are available`;
      }
      return true;
    },
    clickPartCard(part) {
      if (part.isAvailable) {
        this.$set(this.edit_item, 'partId', part.id);
        this.$emit('partChanged', part.id);
        this.changePart();
      }
    },
    setTempEditItem() {
      this.temp_edit_item = {
        externalLocationId: this.location.externalId,
        externalDecorationId: this.decoration.externalId,
        externalDecorationColorId: this.decoration_color.externalId
      };
      console.log('setTempEditItem', this.temp_edit_item);
    }
  }
};
</script>

<style scoped></style>
